import { combineReducers } from 'redux';
import admIdReducer from './admIdReducers';

const rootReducer = combineReducers({
    admId: admIdReducer
});

export default rootReducer;
 